module.exports = __webpack_public_path__ + "img/ry6.222258fd.jpeg";